export const listReport = {
  table: {
    date: '日付',
    total: '合計',
    reset: 'リセット',
    export: 'エクスポート',
    hour: '(単位　ｈ)',
  },
  pageHeader: {
    title: '洗浄回数',
  },
  filter: {
    filterDay: '洗浄回数管理 日別',
    filterByRangeDay: '洗浄回数管理 期間指定日別',
    filterByTime: '期間指定 洗浄回数集計',
  },
  hooks: {
    selectRangeDateFail: '範囲の日付が無効です',
  },
}
